import { getAuthHeader, history } from '../helpers';
import { apiConfig } from './apiConfig';
import { DEFAULT_API_CONFIG } from './apiConfig';

const handleResponse = response => {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        history.push('/');
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
};

export const getAutomations = () => {

const { getHeaders, url } = DEFAULT_API_CONFIG;
const automationsUrl = `${url}/automationsui/list`

  const headers = getHeaders();
  const requestOptions = {
    method: 'GET',
    headers,
  };
  return fetch(automationsUrl, requestOptions).then(handleResponse);
}; 


export const getAutomationById = (automationId) => {
  const { getHeaders, url } = DEFAULT_API_CONFIG;
  const automationUrl = `${url}/automationsui/${automationId}`;
  const headers = getHeaders();
  const requestOptions = {
    method: 'GET',
    headers,
  };
  return fetch(automationUrl, requestOptions).then(handleResponse);
};


export const getAutomationRunById = (automationRunId) => {
  const { getHeaders, url } = DEFAULT_API_CONFIG;
  const automationRunUrl = `${url}/automationsui/run/${automationRunId}`;
  const headers = getHeaders();
  const requestOptions = {
    method: 'GET',
    headers,
  };
  return fetch(automationRunUrl, requestOptions).then(handleResponse);
};


export const getAutomationLogById = (automationLogId) => {
  const { getHeaders, url } = DEFAULT_API_CONFIG;
  const automationLogUrl = `${url}/automationsui/log/${automationLogId}`;
  const headers = getHeaders();
  const requestOptions = {
    method: 'GET',
    headers,
  };
  return fetch(automationLogUrl, requestOptions).then(handleResponse);
};


export const setAutomationShouldRun = (automationId, shouldRun) => {
  const { getHeaders, url } = DEFAULT_API_CONFIG;
  const shouldRunUrl = `${url}/automationsui/${automationId}/shouldrun`;
  const headers = getHeaders();
  const requestOptions = {
    method: 'PATCH',
    headers,
    body: JSON.stringify({ shouldRun }),
  };
  return fetch(shouldRunUrl, requestOptions).then(handleResponse);
};


export const runAutomationNow = (automationId) => {
  const { getHeaders, url } = DEFAULT_API_CONFIG;
  const runNowUrl = `${url}/automationsui/${automationId}/run`;
  const headers = getHeaders();
  const requestOptions = {
    method: 'POST',
    headers,
  };
  return fetch(runNowUrl, requestOptions).then(handleResponse);
};


export const resetAutomationStatus = (automationId) => {
  const { getHeaders, url } = DEFAULT_API_CONFIG;
  const resetUrl = `${url}/automationsui/${automationId}/resetstatus`;
  const headers = getHeaders();
  const requestOptions = {
    method: 'POST',
    headers,
  };
  return fetch(resetUrl, requestOptions).then(handleResponse);
};